import React, { Component } from 'react';
import FrontHeader from '../FrontHeader/frontHeader';
import { AppProvider } from '@/modules/storefront/hooks/appContext';
import Home from '../../HomePage/home';
import Endpoint from '@/modules/storefront/utils/endpoint';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const FrontBody = () => {
  Endpoint.init();
  return (
    <>
      <AppProvider>
        <FrontHeader />
        <Home />
      </AppProvider>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  )
}

export default FrontBody;
